// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
export type ServerDebugInfoFragment = {
  __typename?: "Server";
  humanId: string;
  lastReceivedSnapshotAt?: number | null;
  lastTestSnapshotAt?: number | null;
  lastSnapshotSubmitter?: string | null;
  duplicateSnapshotReceivedAt?: number | null;
  displaySystemType?: string | null;
  systemScope?: string | null;
  systemId?: string | null;
  clusterId?: string | null;
  postgresVersion?: string | null;
  latestStats?: {
    __typename?: "PostgresServerStats";
    pgStatStatementsDealloc?: number | null;
    pgStatStatementsReset?: number | null;
  } | null;
};

export const ServerDebugInfoFragmentDoc = gql`
  fragment ServerDebugInfo on Server {
    humanId
    lastReceivedSnapshotAt
    lastTestSnapshotAt
    lastSnapshotSubmitter
    duplicateSnapshotReceivedAt
    displaySystemType
    systemScope
    systemId
    clusterId
    postgresVersion
    latestStats {
      pgStatStatementsDealloc
      pgStatStatementsReset
    }
  }
`;
